import React, { useEffect } from 'react';
import { useController, UseControllerProps } from 'react-hook-form';
import { Form, SelectProps } from 'semantic-ui-react';
import { getLabel } from './util';
import styled, { CSSProperties } from 'styled-components';

interface SelectFormFiled extends UseControllerProps {
  label?: string | JSX.Element;
  value?: any;
  control: any;
  withoutLabel?: boolean
  disableScroolIntoView?: boolean
  dynamicError?: string | null
  noErrorMessage?: boolean
  withoutAsterisk?: boolean
  maxHeightMenu?: CSSProperties['maxHeight']
}

type SelectFormFiledProps = SelectFormFiled & SelectProps;

const StyledFormSelect = styled(Form.Select)<{$maxHeightMenu?: string}>`
 & > div {
   & [role="listbox"] {
     ${props => props.$maxHeightMenu && `max-height: ${props.$maxHeightMenu} !important;`}
   }
 }
`

const Select = React.forwardRef<any, SelectFormFiledProps>((props, ref) => {

  const {
    control,
    label,
    name,
    rules,
    value,
    options,
    disableScroolIntoView,
    noErrorMessage,
    withoutLabel,
    maxHeightMenu,
    ...selectProps
  } = props;

  const { field, fieldState } = useController({ name, control, rules });
  const fieldTemp = { ...field, ref: null as any };

  function notInViewport(element: any, offset = 0) {
    if (!element) return false;
    const top = element.getBoundingClientRect().top;
    return top + offset >= 0 && top - offset >= window.innerHeight;
  }

  useEffect(() => {
    if (fieldState.error && !disableScroolIntoView) {
      const element = document.getElementById(fieldTemp.name);
      if (notInViewport(element)) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'start' });
      }
    }
  }, [fieldState, props.rules, field.value]);

  function getDefaultValue() {
    if (props.multiple) {
      return []
    }
    return ''
  }

  return (
    <StyledFormSelect
      id={fieldTemp.name}
      ref={ref}
      selectOnBlur={false}
      $maxHeightMenu={maxHeightMenu}
      error={Boolean(fieldState.error)}
      options={options || []}
      {...fieldTemp}
      onChange={(e, data) => fieldTemp.onChange(data.value)}
      {...selectProps}
      label={withoutLabel ? null : getLabel(label, rules, fieldState, props.withoutAsterisk, noErrorMessage)}
      value={value ? value : fieldTemp.value || getDefaultValue()}
    />
  );
});

Select.displayName = 'Select';

export default Select;
